/**
 * @class
 * Collection to handle attribute profiles
 * https://kb.netx.net/display/DEV/Attribute+Profiles+for+Folders
 */

import Base from '@netx/core/lib/netx-collection';
import Model from '../models/attributeProfile';
import Netx from '@netx/core/bootstrap';
import PagerModel from '@netx/core-app/models/pager';
import SorterModel from '@netx/core-app/models/sorter';

import {ATTRIBUTE_PROFILE_EVENT} from '@netx/core-attribute-profile/actions';

export default class AttributeProfiles extends Base {
	/**
	 * @type {Netx.Rpc}
	 * @private
	 */
	get rpc() {
		return true;
	}

	/** @type {boolean} */
	get xhrTrackProgress() {
		return true;
	}

	/** @type {object} */
	get xhrLoadingMessages() {
		return {
			getAttributeProfiles: 'Loading attribute profiles',
		};
	}

	/** @type {object} */
	get xhrLoadedMessages() {
		return {
			getAttributeProfiles: 'Loaded attribute profiles',
		};
	}

	/** @type {object} */
	get methods() {
		return {
			read() {
				return [
					'getAttributeProfiles',
					this.filterStr,
					this.sorter.getSortDTO(),
					this.pager.getPageDTO(),
				];
			},
			getAttributeProfileForFolder: (folderId, opts) => [
				'getAttributeProfileForFolder',
				folderId,
			],
		};
	}

	/** @type {object} */
	get parsers() {
		return {
			getAttributeProfileForFolder: (data, opts) => {
				return data;
			},
		};
	}

	/** @override */
	constructor(models, opts = {}) {
		opts.model = opts.model || Model;
		super(models, opts);

		/**
		 * Paging model
		 * @memberOf Netx.Collections.AttributeProfiles
		 * @alias pager
		 * @type {Netx.Models.Pager}
		 */
		this.pager = new PagerModel(
			Object.assign(
				{
					// TODO: collections/models should not need to know about routes/routing
					routesToPage: false,
				},
				opts.pager,
			),
			{collection: this},
		);

		/**
		 * Sorting model
		 * @memberof module:asset/collections/participants
		 * @alias sorter
		 * @type {module:app/models/sorter}
		 */
		this.sorter = new SorterModel(
			{
				field: opts.sortField || 'name',
				order: opts.sortOrder || 'desc',
			},
			{
				collection: this,
				sortableFields: ['name'],
			},
		);
		this.addSubModel(this.sorter);

		// Add model to collection after successful edit
		this.listenTo(
			dispatcher,
			`${ATTRIBUTE_PROFILE_EVENT.EDIT}:success`,
			(attributeProfile) => {
				this.add(attributeProfile, {merge: true});
				this.trigger('sync', this);
			},
		);
	}

	/** @type {string} */
	static get __name__() {
		return 'AttributeProfiles';
	}
}
